// ##### Komarov 2025-07-18
import React from 'react';
// ##### Komarov 2025-07-18
import { useDispatch, useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../../hooks/useLocalizedText.js';
// ##### Komarov 2025-07-19
import { setPaxListOpen } from '../../../../../Redux/actions/paxchoice.js';

// ##### Komarov 2025-08-05
const PaxPopUpButton = ({ marginTop = null }) => {
  const Confirm = useLocalizedText('Confirm');
  // ##### Komarov 2025-07-18
  const dispatch = useDispatch();

  return (
    <button
      data-component="PaxPopUpButton"
      type="button"
      className="PopUpButton"
      // ##### 23-04-28 Komarov
      onClick={e => {
        // ##### Komarov 2025-07-18
        dispatch(setPaxListOpen(false));
        e.stopPropagation();
      }}
      onKeyDown={e => {
        // Trigger click action on Enter key press
        if (e.key === 'Enter') {
          // ##### Komarov 2025-07-18
          dispatch(setPaxListOpen(false));
          e.stopPropagation();
        }
      }}
      // ##### 23-03-01 Komarov
      style={{ marginTop }}
    >
      {/* ##### 23-09-14 Komarov */}
      {
        // ##### 23-10-04 Komarov
        Confirm
      }
    </button>
  );
};

export default PaxPopUpButton;
